import type { JSX } from 'react'
import type { ButtonLoaderSizes } from './Button.h'

import { loaderBoxSizeMap, loaderInsetMap, loaderStrokeMap } from './Button.h'
import { ButtonLoaderSC } from './ButtonLoader.styled'

interface ButtonLoaderProps {
  loaderSize: ButtonLoaderSizes
  hasTitle: boolean
}

export const ButtonLoader = ({
  loaderSize,
  hasTitle,
}: ButtonLoaderProps): JSX.Element => {
  const boxSize = loaderBoxSizeMap[loaderSize]
  const inset = loaderInsetMap[loaderSize]
  const stroke = loaderStrokeMap[loaderSize]
  const radius = (boxSize - inset * 2 - stroke) / 2

  return (
    <ButtonLoaderSC loaderSize={loaderSize} hasTitle={hasTitle}>
      <svg viewBox={`0 0 ${boxSize} ${boxSize}`} aria-hidden='true'>
        <circle cx={boxSize / 2} cy={boxSize / 2} r={radius} pathLength={100} />
      </svg>
    </ButtonLoaderSC>
  )
}
